import React from "react";
import { StyledInput } from "./styles";

export type InputType = "text" | "password";

export interface InputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "placeholder"
  > {
  placeholder: string;
  type?: InputType;
  value: string;
  setValue: (value: string) => void;
}

export const InputLogin: React.FC<InputProps> = ({
  placeholder,
  type = "text",
  setValue,
  value,
  ...rest
}) => {
  return (
    <StyledInput
      placeholder={placeholder}
      type={type}
      {...rest}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

export default InputLogin;
